
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/greining",
      function () {
        return require("private-next-pages/greining.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/greining"])
      });
    }
  